
































































































































































import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import * as broadCastsService from '@/services/broadcast'
import { checkStatusMap } from '@/constants/statusMap'
import Popup from '@/components/popup/index.vue'

interface CurType {
  id?: number
}

@Component({ components: { HeaderBar, Popup } })
export default class Playlists extends Vue {
  isOperate = false
  isDel = false
  isCheck = false
  curPlaylist: CurType = {}
  result = {}
  pageNo = 1
  checkStatusMap = checkStatusMap
  $toast: any
  isloading = false

  get playlists() {
    return (
      (this.$store.state.broadcasts && this.$store.state.broadcasts.list) || []
    )
  }

  get checkUserStatus() {
    if (
      this.$store.state.userInfo.extInfo &&
      !isNaN(this.$store.state.userInfo.extInfo.settledStatus)
    ) {
      return this.$store.state.userInfo.extInfo.settledStatus
    }
    return -1
  }

  created() {
    // if (this.playlists && this.playlists.length == 0) {
    this.fetchPlaylists()
    // }
  }
  //点击出操作浮层
  operate(data = {}) {
    this.curPlaylist = data
    this.isOperate = true
  }
  fetchPlaylists() {
    return this.$store.dispatch('broadcasts/fetchUserPlaylist', {
      uuid: this.$store.state.userInfo.uuid,
      pageNo: 1,
      pageSize: 200,
    })
  }
  //发布播单
  async pubPlaylist() {
    if (this.isloading) {
      return
    }
    if (this.curPlaylist.id) {
      this.isOperate = false
      this.updateList(1)
      this.$toast('操作上线中，请等待')
      this.isloading = true
      await broadCastsService.pubPlaylist(this.curPlaylist.id)
      this.isloading = false
    }
  }
  //取消发布播单
  async delPubPlaylist() {
    if (this.isloading) {
      return
    }
    if (this.curPlaylist.id) {
      this.isOperate = false
      this.updateList(-5) //下线中
      this.$toast('操作下线中，请等待')
      this.isloading = true
      await broadCastsService.delPubPlaylist(this.curPlaylist.id.toString())
      console.log(111)
      this.isloading = false
    }
  }
  //查看原因
  async checkResult() {
    if (this.isloading) {
      return
    }
    if (this.curPlaylist.id) {
      this.isloading = true
      const data = await broadCastsService.getPlayLogs(this.curPlaylist.id)
      this.isloading = false
      this.isOperate = false
      this.isCheck = true
      if (data.code == 200 && data.data) {
        this.result = data.data[0]
      }
    }
  }
  //删除播单
  async delPlaylist() {
    if (this.isloading) {
      return
    }
    if (this.curPlaylist.id) {
      this.isloading = true
      const data = await broadCastsService.deletePlaylist(
        this.curPlaylist.id.toString()
      )
      this.isloading = false
      this.$toast(data.msg)

      if (data.code != 200) {
        return
      }

      this.isOperate = false
      this.isDel = false
      const newArr: Array<object> = []
      for (let i = 0; i < this.playlists.length; i++) {
        if (this.curPlaylist.id == this.playlists[i].id) {
          continue
        }
        newArr.push(this.playlists[i])
      }
      this.$store.commit('broadcasts/setPlaylists', newArr)
    }
  }
  //更新播单列表
  updateList(type: number) {
    const newArr: Array<object> = []
    for (let i = 0; i < this.playlists.length; i++) {
      if (this.curPlaylist.id == this.playlists[i].id) {
        this.playlists[i].checkState = type
      }
      newArr.push(this.playlists[i])
    }

    this.$store.commit('broadcasts/setPlaylists', newArr)
  }
  toSchema(item: any) {
    if (item.checkState == 6) {
      window.location.href = `imgotv://player?plId=${item.vrsId}`
    }
  }
}
